import APIClient from '@/shared/http/clients/api'

const resourceName = 'relatorio/geral-campanha'
const APICore = process.env.APIBaseURLCore

const GetAllCampanhaReport = (dataFilters, limit, index, config = {}) => APIClient.post(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, dataFilters, config)
const ExportAllCampanhaReport = (dataFilters, config = {}) => APIClient.post(`${APICore}/${resourceName}/export`, dataFilters, config)

const ReportCampanhaGeralRepository = {
  GetAllCampanhaReport,
  ExportAllCampanhaReport
}

export default ReportCampanhaGeralRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/reports/reportCampanha.js